import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import ImageBackground from '@hfe/max-imagebackground';
import LinearGradient from '@hfe/max-linear-gradient';
import { navigateTo } from '@max/meituan-uni-navigate';
import Sensor from '@max/mbc-sensor';
import './index.scss';
import { PlatformType, R_MC, R_MV, TYPE } from '../constants';
import { getPlatformType } from '@nibfe/mkt-env-api';
const StrategyGuide = (props) => {
    const { jumpLink, bgImageURL, buttonConfig } = props?.config;
    const { mcReport, mvReport } = props?._LXReport;
    const platformType = getPlatformType();
    const isMT = platformType === PlatformType.mtApp || PlatformType.mtAppWebView;
    const handleClick = () => {
        mcReport(R_MC, {
            valLab: {
                type: TYPE.STRATEGY
            }
        });
        if (isMT) {
            navigateTo({
                url: jumpLink,
                _web: {
                    miniProgramNative: true
                }
            });
        }
        else {
            navigateTo({
                url: `https://w.dianping.com/cube/evoke/meituan.html?url=${encodeURIComponent(jumpLink)}`,
                _web: {
                    miniProgramNative: true
                }
            });
        }
    };
    const handleAppera = () => {
        mvReport(R_MV, {
            valLab: {
                type: TYPE.STRATEGY
            }
        });
    };
    return <Sensor once onAppear={() => handleAppera()} style={{
            width: '100%',
            height: '100%'
        }}>
            <View className="strategy-guide-container" onClick={() => handleClick()}>
                <ImageBackground source={{
            uri: bgImageURL
        }} className="strategy-guide-bg-image">
                    <View className="strategy-guide-button">
                        <LinearGradient className="strategy-guide-button-linear" start={{
            x: 0,
            y: 0
        }} end={{
            x: 1,
            y: 0
        }} colors={[buttonConfig.buttonBgColorStart || '#FF7F2F', buttonConfig.buttonBgColorEnd || '#FF2D19']}>
                            <Text className="strategy-guide-button-text" style={{
            color: buttonConfig.buttonTextColor || '#fff'
        }}>{buttonConfig.buttonText}</Text>
                        </LinearGradient>
                    </View>
                </ImageBackground>
            </View>
        </Sensor>;
};
export default memo(StrategyGuide);
